export default __webpack_public_path__ + "static/media/icn-ai-sparkle.a2ca759e.svg";